import { cn, Label, Tooltip, TooltipContent, TooltipTrigger } from '@design-system';
import { Info } from 'lucide-react';
import type { ReactNode } from 'react';

interface FieldLabelProps {
  label: string;
  tooltip: string | ReactNode;
  className?: string;
  required?: boolean;
}

/**
 * Form field label with an info-icon tooltip. Renders an inline red asterisk
 * when `required` to match the guided-planning convention.
 */
export function FieldLabel({ label, tooltip, className, required }: FieldLabelProps) {
  return (
    <Label className={cn('block text-sm font-medium', className)}>
      {label}
      {required && (
        <span
          className="ml-0.5 text-red-500"
          aria-hidden
        >
          *
        </span>
      )}{' '}
      <Tooltip>
        <TooltipTrigger className="inline-block -translate-y-px align-middle">
          <Info className="text-muted-foreground size-3.5 shrink-0 cursor-help" />
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="max-w-xs"
        >
          <p className="text-sm">{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </Label>
  );
}

export function ErrorMessage({ message }: { message?: string }) {
  if (!message) return null;
  return <p className="text-sm text-red-500">{message}</p>;
}
